module.exports = __webpack_public_path__ + "assets/img/37.099cb546.png";